import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { iApplyFormControl, ControlRegexValidator } from "app/shared/model";
import { isEmptyInputValue } from "./validation-shared";
import _ from "lodash";

export class ControlValidators
{
    static RegexValidator(control: iApplyFormControl, validators: ControlRegexValidator[]): ValidatorFn
    {
        return (control: AbstractControl): ValidationErrors | null =>
        {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }

            try {
                let errors = [];
                let passed = false;
                validators.forEach((controlValidator: ControlRegexValidator) =>
                {
                    const regex = new RegExp(controlValidator.validator.regex);
                    if (regex.test(control.value)) {
                        passed = true;
                        return;
                    }

                    errors.push(controlValidator.message ?? controlValidator.validator.defaultMessageTemplate);
                });

                return passed ? null : { 'regex': true, 'regexErrors': errors };
            }
            catch (ex)
            {
                return {
                    'regex': true,
                    'regexErrors': [ex]
                }
            }
        }
    }
}
